import AppModule from '../../App.module.scss'
import Footer from '../../components/Common/Footer'
import { auth } from '../../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import UserInfo from '../../components/UserInfo/UserInfo'
import Header from '../../components/Header/Header'
import React from 'react'

function MyPage() {
  const [user] = useAuthState(auth)
  console.log('user', user)
  if (user && user.uid) {
    const newUrl = `/mypage?uid=${user.uid}`
    if (window.location.pathname + window.location.search !== newUrl) {
      window.history.replaceState(null, '', newUrl)
    }
  }

  return (
    <div className={AppModule.main}>
      <Header title="マイページ" />
      {user ? <UserInfo /> : <></>}
      <Footer />
    </div>
  )
}
export default MyPage
